<div 
    class="relative bg-white rounded-lg flex flex-col plan-card"
    [class]="cardClasses()"
    [class.ring-2]="selected() || (showPopularRing() && plan().popular)"
    [class.ring-brand-orange-500]="selected()"
    [class.ring-brand-purple-500]="!selected() && showPopularRing() && plan().popular">
    
    <!-- Plan Name -->
    <h3 [class]="nameClasses()" class="plan-name m-0 mb-0 p-0">{{ plan().name }}</h3>
    
    <!-- Pricing -->
    <div [class]="priceContainerClasses()">
    @if (displayPrice() !== null) {
        <!-- Show strikethrough original price if discount exists -->
        @if (showDiscount()) {
            <div class="text-center discount-price m-0 text-xs h-[0.95em]">
                <span [class]="strikethroughPriceClasses()">{{ currencySymbol() }}{{ formattedBasePrice() }}</span>
            </div>
        } @else {
            <div class="text-center discount-price discount-placeholder m-0 text-xs h-[0.95em]">
                &nbsp;
            </div>
        }
        
        <div class="flex items-end justify-center gap-1">
        <span [class]="currencyClasses()">{{ currencySymbol() }}</span>
        <span [class]="priceClasses()">
            {{ formattedPrice() }}
        </span>
        <span [class]="periodClasses()">/mo</span>
        </div>
        
        <!-- Price description text (e.g., "per seat", "for 3 seats") -->
        @if (priceDescriptionText()) {
            <div [class]="priceDescriptionClasses()">
                {{ priceDescriptionText() | truncate: 30 }}
            </div>
        }
    } @else {
        <div class="text-center discount-price discount-placeholder m-0 text-xs h-[0.95em]">
            &nbsp;
        </div>
        <div [class]="priceClasses()">Custom</div>
        @if (size() === 'default') {
        <div class="text-xs text-base-400 mt-2">
            &nbsp;
        </div>
        }
    }
    
    <!-- Seats/Users Info (for ranged pricing without description text) -->
    @if (showSeatsInfo() && displayPrice() !== null && !priceDescriptionText()) {
        <div [class]="seatsInfoClasses()">
        <div><span class="font-normal">Includes </span><span class="font-bold">{{ includedSeats() }} {{ rangedValueName() }}</span></div>
        @if (additionalSeatPrice() && size() === 'default') {
            <div class="mt-1">
            <span class="font-normal">Additional {{ plan().name }} Seat from:</span> <span class="font-bold">{{ additionalSeatPrice() }}/mo</span>
            </div>
        }
        </div>
    } @else if (size() === 'compact' || size() === 'comparison-mobile') {
        <!-- Placeholder for alignment in compact mode -->
        @if (displayPrice() == null) {
            <div class="h-[1.25em]">
                
            </div>
        }
    }
    </div>
    
    <!-- Description (hidden in comparison-mobile) -->
    @if (showDescription() && size() !== 'compact') {
      <p [class]="descriptionClasses()" class="min-h-8">{{ plan().description || 'Ideal for small team or businesses' | truncate: 60 }}</p>
    }

    @if(size() == 'compact' && showDescription()) {
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"
          class="w-3 h-3 mt-1 opacity-60 cursor-help hover:opacity-100 transition-opacity absolute right-2 top-2"
          [appTooltip]="plan().description"
          tooltipPosition="bottom"
          role="img" aria-label="Info">
          <path d="M4.545 4.5C4.66255 4.16583 4.89458 3.88405 5.19998 3.70457C5.50538 3.52508 5.86445 3.45947 6.21359 3.51936C6.56273 3.57924 6.87941 3.76076 7.10754 4.03176C7.33567 4.30277 7.46053 4.64576 7.46 5C7.46 6 5.96 6.5 5.96 6.5M6 8.5H6.005M11 6C11 8.76142 8.76142 11 6 11C3.23858 11 1 8.76142 1 6C1 3.23858 3.23858 1 6 1C8.76142 1 11 3.23858 11 6Z" stroke="#5B6A8F" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    }
    
    <!-- CTA Button -->
    <button 
    [class]="buttonClasses()"
    (click)="onPlanClick()">
    @if (displayPrice() === null) {
        Contact Sales
    } @else {
        {{ ctaLabel() || 'Choose Plan' }}
    }
    </button>
    
    <!-- Highlighted Features (default size only) -->
    @if (showHighlights() && highlightedFeatures().length > 0) {
    <!-- Divider -->
    <div class="border-t border-gray-200 my-2"></div>
    
    <div class="pt-4">
        <div class="text-xs font-bold text-base-300 uppercase tracking-wide mb-4">HIGHLIGHTS</div>
        <div class="space-y-2">
        @for (feature of highlightedFeatures(); track feature.code) {
            <div class="flex items-center gap-2">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M15.8254 15.8334H15.8333ZM15.8254 15.8334C15.3065 16.348 14.366 16.2198 13.7065 16.2198C12.897 16.2198 12.5072 16.3782 11.9295 16.9559C11.4375 17.4479 10.778 18.3334 9.99996 18.3334C9.22188 18.3334 8.56238 17.4479 8.07043 16.9559C7.49269 16.3782 7.10287 16.2198 6.29334 16.2198C5.63386 16.2198 4.69344 16.348 4.17453 15.8334C3.65147 15.3147 3.78019 14.3704 3.78019 13.7067C3.78019 12.8679 3.59676 12.4822 2.99944 11.8849C2.11091 10.9964 1.66664 10.5521 1.66663 10.0001C1.66663 9.448 2.11089 9.00375 2.99942 8.11522C3.53263 7.58201 3.78019 7.05365 3.78019 6.29346C3.78019 5.63396 3.65203 4.69353 4.16663 4.17461C4.68532 3.65156 5.62963 3.7803 6.29336 3.7803C7.05352 3.7803 7.58189 3.53275 8.11508 2.99956C9.00363 2.11101 9.44788 1.66675 9.99996 1.66675C10.552 1.66675 10.9963 2.11101 11.8848 2.99956C12.4179 3.53264 12.9462 3.7803 13.7065 3.7803C14.366 3.7803 15.3065 3.65214 15.8255 4.16675C16.3485 4.68544 16.2197 5.62974 16.2197 6.29346C16.2197 7.13223 16.4032 7.51789 17.0005 8.11522C17.889 9.00375 18.3333 9.448 18.3333 10.0001C18.3333 10.5521 17.889 10.9964 17.0005 11.8849C16.4031 12.4822 16.2197 12.8679 16.2197 13.7067C16.2197 14.3704 16.3485 15.3147 15.8254 15.8334Z" fill="#5B6A8F"/>
                <path d="M7.5 10.7442L9 12.0834L12.5 7.91675" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="text-xs font-semibold text-base-400 flex-1">{{ feature.name }}</span>
            <div [appTooltip]="feature.description || ''">
                <svg class="w-4 h-4 text-base-400 flex-shrink-0 cursor-help" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
            </div>
            </div>
        }
        </div>
    </div>
    }
</div>